import React, { useId, useState } from 'react';
import Error from "../assets/error.svg?react"
import EyeHide from "../assets/eye-hide.svg?react"
import Check from "../assets/checks.svg?react"
import Eye from "../assets/eyes.svg?react"
import classNames from 'classnames';
import { Asterisk } from './Asterisk';

declare type InputFieldProps = {
    required?: boolean | undefined;
    label?: string;
    showTips: boolean | undefined;
    error: string | undefined;
    tips?: {
        placeholder?: string | undefined;
        error?: string | undefined;
        success?: string | undefined;
    }
    className?: string;
    inputProps: React.ComponentProps<'input'>;
}

declare type CustomFieldProps = {
    required?: boolean | undefined;
    label?: string;
    showTips: boolean | undefined;
    error: string | undefined;
    tips?: {
        placeholder?: string | undefined;
        error?: string | undefined;
        success?: string | undefined;
    }
    className?: string;
    children: React.ReactNode;
}

declare type FieldProps = InputFieldProps | CustomFieldProps;

export const Field = (props: FieldProps) => {
    const {required = false, label, showTips, error, tips, className} = props;
    const [showPass, setShowPass] = useState(false);
    const id = useId();

    return (
        <div className={className}>
            {label && (
                <label className="block text-[#1C1C1C] leading-4 font-semibold pb-1.5" htmlFor={id}>
                    {label}{required && <Asterisk />}
                </label>
            )}
            {
                'children' in props && (
                    props.children
                )
            }
            { 'inputProps' in props && (
                <div
                    className={classNames({
                        'flex flex-row place-items-center h-11 px-3.5 rounded-lg border border-[#D1D5DB] text-[#1C1C1C] outline-none bg-[#F9FAFB] w-full': true,
                        'border border-[#FF5959]': showTips && error,
                        'border-green-500': showTips && !error,
                    })}>
                    <input
                        id={id}
                        className="border-none bg-transparent focus-visible:outline-none w-full"
                        {...props.inputProps}
                        type={props.inputProps.type === "password" && showPass ? "text" : props.inputProps.type}
                        required={required}
                    />
                    {
                        props.inputProps.type === "password" && showPass && (
                            <Eye
                                className="cursor-pointer"
                                onClick={() => setShowPass(false)}
                            />
                        )
                    }
                    {
                        props.inputProps.type === "password" && !showPass && (
                            <EyeHide
                                className="cursor-pointer"
                                onClick={() => setShowPass(true)}
                            />
                        )
                    }
                </div>
            )}
            {tips?.placeholder && !showTips && !error && <p className="text-[#595959] mt-2">{tips.placeholder}</p>}
            {tips?.success && showTips && !error && <p className="text-[#22AD5C] mt-2 flex items-center"><Check className='mr-1'/> {tips.success}</p>}
            {error && <p className="text-[#FF5959] mt-2 flex items-center"><Error className='mr-1'/> {error}</p>}
        </div>
    )
}